module.exports = __webpack_public_path__ + "static/media/icon-arrow-next.02ae871b.svg";